var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5876 5.48924C16.7887 3.6146 13.9187 3.50979 12 5.17481C10.0813 3.50982 7.21132 3.61463 5.41239 5.48927C3.5292 7.4517 3.5292 10.617 5.41239 12.5795L11.2785 18.6924C11.467 18.8889 11.7276 19 12 19C12.2724 19 12.5329 18.8889 12.7215 18.6924L18.5876 12.5794C20.4708 10.617 20.4708 7.45168 18.5876 5.48924ZM13.1126 6.87402C14.2309 5.70866 16.0263 5.70866 17.1446 6.87402C18.083 7.85196 18.2493 9.34093 17.6435 10.5H14.2C13.9661 10.5 13.7395 10.582 13.5598 10.7318L12.6568 11.4843L10.8575 8.4855C10.6794 8.18871 10.3605 8.00511 10.0144 8.0001C9.66836 7.9951 9.3443 8.16942 9.15773 8.46095L7.85273 10.5H6.35648C5.75068 9.34093 5.917 7.85197 6.85544 6.87404C7.97374 5.70868 9.76911 5.70868 10.8874 6.87404L11.2785 7.28155C11.467 7.47807 11.7276 7.58916 12 7.58916C12.2724 7.58916 12.5329 7.47807 12.7215 7.28155L13.1126 6.87402ZM8.10804 12.5L12 16.5557L15.8919 12.5H14.5621L13.0402 13.7682C12.8158 13.9552 12.5209 14.0347 12.233 13.986C11.945 13.9372 11.6928 13.7649 11.5425 13.5145L9.97258 10.8979L9.24227 12.0391C9.05846 12.3263 8.74098 12.5 8.4 12.5H8.10804Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperature);
export default __webpack_public_path__ + "static/media/icon_temperature.d2aa0237f9710ad7409e34c40d4b62d3.svg";
export { ForwardRef as ReactComponent };